import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Resellers from "components/Panel/Admin/Resellers";
import Button from "components/Button";
import { Link } from "react-router-dom"
import Pagination from "components/Pagination";
import { useDebounce } from "use-debounce";

import { getResellers } from "redux/admin/users/usersSlice";

const ResellersContainer = () => {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [showInactive, setShowInactive] = useState(false);
  const [debouncedSearch] = useDebounce(search, 500);
  const { data } = useSelector(state => state.adminUsers.resellers);
  const { total, pages, page, per_page } = useSelector(state => state.adminUsers.resellers);
  
  useEffect(() => {
    dispatch(getResellers({ page: 1, per_page: 30, show_inactive: showInactive, search: debouncedSearch }))
  }, [dispatch, debouncedSearch, showInactive])

  const handlePageChange = (newPage) => {
    dispatch(getResellers({ page: newPage, per_page: 30, show_inactive: showInactive, search: debouncedSearch }))
  };

  return (
    <div className="bg-black min-h-screen">
      <div className="p-4 flex items-center justify-between">
        <h2 className="text-xl font-semibold text-white-100">Bayi Listesi</h2>
        <Link to="/admin/resellers/create"> <Button size="small">Bayi Ekle</Button></Link>
      </div>
      <div className="px-4 mb-4 flex items-center space-x-4">
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          type="text"
          className="border border-gray-500 rounded-lg p-2 w-80"
          placeholder="Bayi Adı, Telefon, Payment Key"
        />
        <div className="flex items-center text-white">
          <input
            type="checkbox"
            id="showInactive"
            checked={showInactive}
            onChange={(e) => setShowInactive(e.target.checked)}
            className="mr-2"
          />
          <label htmlFor="showInactive">Pasif Bayileri Göster</label>
        </div>
      </div>
      <Resellers data={data} />
      <Pagination currentPage={page} totalPages={pages} onPageChange={handlePageChange} />
    </div>
  );
};

export default ResellersContainer;
